<div class="p-a-xxl cipo--height--full cipo--overflow--auto">
    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        @for (field of fields; track $index) {
            <cipo-text-view
                fxFlex="16"
                [value]="field.value"
                [readonlyConfig]="field.readonlyConfig"
                [config]="field.config" />
        }
    </div>
    <div fxLayout="row wrap" fxLayoutGap="10px">
        @for (field of fields; track $index) {
            <cipo-text-view
                fxFlex="45"
                [value]="field.value"
                [readonlyConfig]="field.readonlyConfig"
                [config]="field.config" />
        }
    </div>
    <div class="m-t">
        @if (tableField()) {
            <cipo-table-field-view
                [entityInstanceId]="activityItemDetails().entityInstanceId"
                [tableField]="tableField()" />
        }
    </div>
</div>
